/*
 * Public API Surface of inova-core
 */


export * from './entity-data.module';
export * from './components/entity-data/entity-data.component';
export * from './components/delimitation-view/delimitation-view.component';
export * from './components/annexes-view/annexes-view.component';
